import { ReactElement, useContext } from "react";
import { QuestionCategory, TestResult, TestVersion } from "../../api";
import { Typography, Stack, Button, Divider } from "@mui/material";
import { useNavigate } from "react-router";
import { AppContext } from "@cdv/jazz-ui";
import { getResult } from "./utils";

export default function ResultCardCategory({
  version,
  result,
}: {
  version: TestVersion;
  result: Record<QuestionCategory, number>;
}): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  return (
    <>
      <Typography variant="h5" sx={{ textAlign: "center", fontSize: "20px" }}>
        {version.name} - vyhodnocení
      </Typography>
      <Stack sx={{ alignItems: "center", mt: "10px" }}>
        <img src={`/assets/ilu_test2.svg`} style={{ height: "100px" }} />
      </Stack>
      <Typography sx={{ textAlign: "center", mt: "10px", fontSize: "20px" }} variant="h5">
        DEPRESE: {getResult(QuestionCategory.Depression, result[QuestionCategory.Depression]).title}
      </Typography>
      <Typography sx={{ mt: "10px", color: "#00000099" }}>
        {getResult(QuestionCategory.Depression, result[QuestionCategory.Depression]).description}
      </Typography>
      <Divider sx={{ my: "10px" }} />
      <Typography sx={{ textAlign: "center", mt: "10px", fontSize: "20px" }} variant="h5">
        ÚZKOST: {getResult(QuestionCategory.Anxiety, result[QuestionCategory.Anxiety]).title}
      </Typography>
      <Typography sx={{ mt: "10px", color: "#00000099" }}>
        {getResult(QuestionCategory.Anxiety, result[QuestionCategory.Anxiety]).description}
      </Typography>
      <Divider sx={{ my: "10px" }} />
      <Typography sx={{ textAlign: "center", mt: "10px", fontSize: "20px" }} variant="h5">
        STRES: {getResult(QuestionCategory.Stress, result[QuestionCategory.Stress]).title}
      </Typography>
      <Typography sx={{ mt: "10px", color: "#00000099" }}>
        {getResult(QuestionCategory.Stress, result[QuestionCategory.Stress]).description}
      </Typography>
      <Button
        variant="contained"
        color="inherit"
        size="large"
        fullWidth
        sx={{ mt: "10px" }}
        onClick={() => navigate("/info/help")}
      >
        Najít pomoc
      </Button>
    </>
  );
}
